import { dashboardKeys } from '@/features/events/feed/feedQuery';
import type { PatchVenueRequest, VenueDetail } from '@/lib/api/apiTypes';
import { useAuth } from '@/lib/auth/auth';
import { venueDetailKeys } from '@/features/venues/useVenueDetail';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useUpdateVenue(id: string) {
  const request = useAuth((state) => state.request);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PatchVenueRequest) =>
      request<VenueDetail>(`/venues/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(payload),
      }),
    onSuccess: async (data) => {
      queryClient.setQueryData(venueDetailKeys.detail(id), data);
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: venueDetailKeys.detail(id) }),
        queryClient.invalidateQueries({ queryKey: dashboardKeys.current() }),
      ]);
    },
  });
}
